import { useContext, useState, useEffect, useRef } from 'react';
import { PersonContext } from '../../context/PersonContext'; // PersonContext를 가져옵니다. 
import { DialogContext } from '../../context/DialogContext';
import restapi from '../../utils/restapi'; // REST API 유틸리티를 가져옵니다.
import './list.css';
import List from '../../components/List';
import TestingTeacherDocumentJoin from './join'; // 작성 페이지 컴포넌트를 가져옵
import TestingTeacherDocumentView from './view'; // 내용보기 페이지 컴포넌트를 가져옵니다.

const TestingTeacherDocumentList = () => {
  const { person } = useContext(PersonContext); // PersonContext에서 person을 가져옵니다.
  const { openDialog, closeDialog } = useContext(DialogContext); // DialogContext에서 openDialog와 closeDialog를 가져옵니다.

  const listRef = useRef(null);
  const [isDataReady, setIsDataReady] = useState(false);

  // person 데이터가 준비되면 List 컴포넌트 새로고침
  useEffect(() => {
    if (person && person.person_id) {
      console.log('person 데이터가 준비되어 List를 새로고침합니다.');
      setIsDataReady(true);
      
      // List 컴포넌트가 마운트된 후 새로고침 실행
      setTimeout(() => {
        if (listRef.current) {
          listRef.current.refresh();
        }
      }, 100);
    }
  }, [person]);

  // List에서 사용할 데이터 가져오기 함수
  const handleGetData = async (params) => {
    console.log("handleGetData requestParams:", params);
    
    // person이 준비되지 않았으면 빈 결과 반환
    if (!person || !person.person_id) {
      console.log('person 데이터가 없습니다.');
      return { lists: [], total: 0, totalPages: 0 };
    }

    const requestParams = {
      ...params,
      person_id: person.person_id
    };
    
    try {
      const results = await restapi.get_testing_teacher_documents(requestParams);
      return results;
    } catch (error) {
      console.error("Error fetching data:", error);
      return { lists: [], total: 0, totalPages: 0 };
    }
  };
  
  const headers = [
    { 
      name: 'NO.', 
      value: 'c_testing_teacher_document_id',
      renderCell: (item) => item.testing_teacher_document_id
    },
    { 
      name: '문서명', 
      value: 'c_title',
      renderCell: (item) => item.title
    },
    { 
      name: '상태', 
      value: 'c_status',
      renderCell: (item) => item.status === 1 ? '미작성' : '작성완료'
    }
  ];

  const buttons = []; // 버튼 상태를 추가합니다.

  const handleTestingTeacherDocumentClose = () => {
    // 다이얼로그 닫기 후 List 새로고침
    closeDialog();
    if (listRef.current) {
      listRef.current.refresh();
    }
  }

  const handleEditClick = (item) => {
    // 작성하기 버튼 클릭 시 처리 로직을 여기에 추가합니다.
    console.log('작성하기 버튼 클릭:', item);
    // openDialog를 사용하여 작성 페이지를 열기
    const customStyles = {
      overlay: {
        backgroundColor: 'rgba(0, 0, 0, 0.5)', // 배경 색상
      },
      content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        padding: '0',
      },
    };

    openDialog(<TestingTeacherDocumentJoin testingTeacherDocumentObj={item} onSave={handleTestingTeacherDocumentSave} onClose={handleTestingTeacherDocumentClose} />, customStyles);
  };

  const handleViewClick = (item) => {
    // 내용보기 버튼 클릭 시 처리 로직
    const customStyles = {
      overlay: {
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
      },
      content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        padding: '0',
      },
    };

    openDialog(
      <TestingTeacherDocumentView testingTeacherDocumentObj={item} onClose={closeDialog} />,
      customStyles
    );
  };

  const handleTestingTeacherDocumentSave = async (json) => {
    closeDialog(); // 다이얼로그 닫기
  }

  // 액션 버튼 렌더링 함수
  const renderActions = (item, index) => {
    return (
      <>
        {item.status === 1 ? (
          // 상태가 1(미작성)인 경우 - 작성하기 버튼
          <button 
            onClick={() => handleEditClick(item)}
          >
            작성하기
          </button>
        ) : (
          // 상태가 1이 아닌 경우(작성완료) - 내용보기 버튼
          <button 
            onClick={() => handleViewClick(item)}
          >
            내용보기
          </button>
        )}
      </>
    );
  };

  // person 데이터가 준비되지 않으면 로딩 표시
  if (!isDataReady || !person || !person.person_id) {
    return (
      <div id="testing_teacher_document_list">
        <div className="head">
          <h1>서명할 서류목록</h1>
        </div>
        <div className="body">
          <div className="middle">
            <div style={{ textAlign: 'center', padding: '50px' }}>
              데이터를 불러오는 중...
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
      <div id="testing_teacher_document_list">
        <div className="head">
          <h1>서명할 서류목록</h1>
      </div>
      <div className="body">
        <List
            ref={listRef}
            headers={headers}
            buttons={buttons}
            onGetData={handleGetData}
            renderActions={renderActions}
            initialSort="a_place_id"
            initialDesc="desc"
            initialRowsPerPage={20}
          />
      </div>
    </div>
  );
}

export default TestingTeacherDocumentList;